// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const creditScoringItemService = {};

creditScoringItemService.posCalculate = function (data) {
  return lossClient({
    url: `/CreditScoringItem/calculate`,
    // url: `/CreditscoringKKBItem/calculate`,
    method: "post",
    headers: {},
    data: {
      ApplicationID: data,
    },
  });
};

creditScoringItemService.posCreditScoringItemSave = function (data) {
  return lossClient({
    url: `/CreditScoringItem/save`,
    // url: `/CreditscoringKKBItem/save`,
    method: "post",
    headers: {},
    data: data,
  });
};

creditScoringItemService.posCalculateKKB = function (data) {
  return lossClient({ 
    url: `/CreditscoringKKBItem/calculate`,
    method: "post",
    headers: {},
    data: {
      ApplicationID: data,
    },
  });
};

creditScoringItemService.posCreditScoringItemSaveKKB = function (data) {
  return lossClient({ 
    url: `/CreditscoringKKBItem/save`,
    method: "post",
    headers: {},
    data: data,
  });
};

creditScoringItemService.posCreditAssessmentService = function (data) {
  return lossClient({ 
    url: `/CreditAssessment/save`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default creditScoringItemService;
